/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import { Select, MenuItem, AppBar, Toolbar, Typography, RadioGroup, Radio, FormControlLabel,
FormLabel
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import get_token from '../lib/get_token';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onCloseAddPop } = props;
  const token = get_token();
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState('');
  const [sdate, setSdate] = useState(null);
  const [tmcd, setTmcd] = useState("");
  const [pid, setPid] = useState("");
  const [method, setMethod] = useState("");  
  const [name, setName] = useState(""); //*
  const [gubun, setGubun] = useState(""); //*
  const [rate, setRate] = useState(""); //*
  const [amount, setAmount] = useState(0); //*
  const [minPrice, setMinPrice] = useState(0); //*
  const [maxPrice, setMaxPrice] = useState(0); //*
  const [days, setDays] = useState(0); //*

  const onSubmit = async () => {    
    
    const postData = {
      token:token,
      cid:login.cid,
      level:login.level,
      mcd:login.mcd,
      tcid:tcid,
      method:method,
      name:name,
      gubun:gubun,
      rate:rate,
      amount:amount,
      min_price:minPrice,
      max_price:maxPrice,
      days:days,
    }    
    
    let result = await axios.post(configState.api + "/gympass_admin/dcoupon_add", postData );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onCloseAddPop();          
        }
      );
    }
  }

  return (
    <Box>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        {/* 센터명 */}
        <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />                     

        {/* 할인쿠폰명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="name"
            label="할인 쿠폰명"
            size="small"
            sx={{
              width: "300px",
            }}
            autoComplete="off"
            value={name}
            onChange={(e)=>setName(e.target.value)}
          ></TextField>        
        </Box>

        {/* 할인구분 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>할인구분</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="gubun"
            onChange={(e)=>{setGubun(e.target.value)}}
            >
            <FormControlLabel value="할인율" control={<Radio />} label="할인율(%)" />
            <FormControlLabel value="금액" control={<Radio />} label="금액할인" />
          </RadioGroup>
        </FormControl>      

        {/* 할인율 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="rate"
            label="할인율(%)"
            size="small"
            autoComplete="off"
            value={rate}
            sx={{width: 180}}
            onChange={(e)=>setRate(e.target.value)}
            disabled={gubun==='할인율'?false:true}
          ></TextField>
        </FormControl>

        {/* 할인금액 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="amount"
            label="할인금액"
            size="small"
            autoComplete="off"
            value={amount}
            sx={{width: 180}}
            onChange={(e)=>setAmount(e.target.value)}
            disabled={gubun==='금액'?false:true}
          ></TextField>
        </FormControl>      

        <Box display="flex" sx={{mt:2}} >
          {/* 최소금액 */}
          <FormControl
            fullWidth
            sx={{mr:2}}
          >
            <TextField
              name="minPrice"
              label="최소 상품금액 제한"
              size="small"
              autoComplete="off"
              value={minPrice}             
              onChange={(e)=>setMinPrice(e.target.value)}
            ></TextField>
          </FormControl>     

          {/* 최대금액 */}
          <FormControl
            fullWidth
          >
            <TextField
              name="maxPrice"
              label="최대 상품금액 제한"
              size="small"
              autoComplete="off"
              value={maxPrice}             
              onChange={(e)=>setMaxPrice(e.target.value)}
            ></TextField>          
          </FormControl>
        </Box>        

        {/* 유효기간 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="days"
            label="유효기간(일)"
            size="small"
            autoComplete="off"
            value={days}
            sx={{width: 180}}
            onChange={(e)=>setDays(e.target.value)}
          ></TextField>
        </FormControl>         

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onCloseAddPop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
